import { render, staticRenderFns } from "./StepMFA.vue?vue&type=template&id=43a46a2a&scoped=true&"
import script from "./StepMFA.vue?vue&type=script&lang=ts&"
export * from "./StepMFA.vue?vue&type=script&lang=ts&"
import style0 from "./StepMFA.vue?vue&type=style&index=0&id=43a46a2a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a46a2a",
  null
  
)

export default component.exports